import React, { type FC } from 'react';

interface DiscountSvgProps {
    fill?: string;
}

export const DiscountSvg: FC<DiscountSvgProps> = ({ fill = '#F05537' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.89207 1.89204C1.64103 2.14305 1.5 2.48351 1.5 2.8385V5.59224C1.50008 5.9472 1.64116 6.2876 1.89221 6.53855L5.4618 10.1079C5.58611 10.2322 5.73368 10.3308 5.8961 10.3981C6.05852 10.4654 6.23261 10.5 6.40842 10.5C6.58422 10.5 6.75831 10.4654 6.92073 10.3981C7.08315 10.3308 7.23072 10.2322 7.35503 10.1079L10.1081 7.35415C10.359 7.10314 10.5 6.76275 10.5 6.40783C10.5 6.05291 10.359 5.71251 10.1081 5.46151L6.53848 1.89218C6.28761 1.64125 5.94737 1.50019 5.59254 1.5H2.8386C2.48358 1.5 2.1431 1.64102 1.89207 1.89204ZM4.125 5.25C4.74632 5.25 5.25 4.74632 5.25 4.125C5.25 3.50368 4.74632 3 4.125 3C3.50368 3 3 3.50368 3 4.125C3 4.74632 3.50368 5.25 4.125 5.25Z"
                fill={fill}
            />
        </svg>
    );
};
